export enum DateRangeType {
  STATIC = 'STATIC',
  LAST_SEVEN_DAYS = 'LAST_SEVEN_DAYS',
  LAST_MONTH = 'LAST_MONTH',
  LAST_QUARTER = 'LAST_QUARTER',
  LAST_YEAR = 'LAST_YEAR'
}
